import Speaker from "./components/Speaker"

export const PUBLIC_API_SPEAKER = {
    Speaker
}